module.exports = __webpack_public_path__ + "img/akorda-small.86e1bb8e.jpg";